import { CheckoutState } from '../../state';
import { getIsPaymentView } from '../routing';
import { isUserLoggedIn } from '../user';

export const shouldCheckCopyBuyerInformationCheckbox = (
    state: CheckoutState,
) => {
    if (!isUserLoggedIn(state) && getIsPaymentView(state)) {
        return false;
    }

    return true;
};
